import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <Link to="/" className="f-brand" style={{ textDecoration: 'none' }}>
        KJV<span>USA</span>.org
      </Link>
      <p className="f-verse">
        "If the foundations be destroyed, what can the righteous do?" Psalm 11:3
      </p>
      <ul className="f-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/bible">Read the Bible</Link></li>
        <li><Link to="/search">Search KJV</Link></li>
        <li><Link to="/why-kjv">Why the KJV</Link></li>
        <li><Link to="/side-by-side">KJV Side by Side</Link></li>
        <li><Link to="/free-bible">Get a Free Bible</Link></li>
        <li><Link to="/state-mottos">State Mottos</Link></li>
        <li><Link to="/patriotic">Most Patriotic Thing</Link></li>
        <li><Link to="/conservative">Conservative Won't Save</Link></li>
        <li><Link to="/liberal">Liberal Won't Save</Link></li>
        <li><Link to="/apolitical">Apolitical Won't Save</Link></li>
        <li><Link to="/american">American Won't Save</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/faq">FAQ</Link></li>
        <li><Link to="/salvation">How to Be Saved</Link></li>
      </ul>
      <p className="f-copy">© 2025 KJVUSA.org · All glory to God · King James Bible · Public Domain</p>
    </footer>
  );
}
